<template>
    <div>
        <div>
            <div v-for="(name,index) in msg.data" :key="index">
                <p style="background:#f69">{{index}}</p>
                <div v-for="(nameArr,nameIndex) in name">
                    <div v-for="(item,itemIndex) in nameArr">
                        <p style="background:#ccc">{{itemIndex}}</p>
                        <Table @on-selection-change="batchChange($event,index,nameIndex,itemIndex)" border ref="selection" :columns="columns" :data="item"></Table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        props:['msg'],
        data(){
            return{
                columns:[
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },{
                        title: '表头信息',
                        key: 'td'
                    },
                ],
            }
        },
        methods:{
            batchChange(e,boxIndex,navIndex,tabIndex){
                this.msg.init[boxIndex][navIndex][tabIndex]=e;
            },
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/template/split/three.vue